import { BaseAPIResponse } from 'types';
import { baseApi } from './axios';
import { API_ENDPOINT } from 'src/config/env.config';

const baseUrl = `${API_ENDPOINT}/round`;

export const lockRoundTemplateByLabelId = async ({
	labelId,
	isAiInterview,
}: {
	labelId: string;
	isAiInterview: boolean;
}): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(
		`${baseUrl}/lock-round/${labelId}`,
		{},
		{
			params: {
				isAiInterview,
			},
		},
	);
	return response.data;
};
